import { render } from "./fuelconsumption.vue?vue&type=template&id=6c835178"
import script from "./fuelconsumption.vue?vue&type=script&lang=js"
export * from "./fuelconsumption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__